//Core
import {FC} from "react";
//Styles
import {
    BurgerButton,
    MobileHeaderAppBar,
    MobileHeaderLogo
} from "@/components/layout/mobileHeader/MobileHeader.styles";
import {Drawer, Toolbar} from "@mui/material";
//Images
import LogoSvg from "@/assets/svg/logo";
//Hooks
import {useMobileHeader} from "@/components/layout/mobileHeader/useMobileHeader";
import MobileMenu from "@/components/layout/mobileHeader/mobileMenu/MobileMenu";

export const MobileHeader: FC = () => {
    const {
        isLoginPage,
        goToHomepage,
        menuOpen,
        toggleMenu,
        headerClass,
        logoColor
    } = useMobileHeader();

    if (isLoginPage) return null;

    return (
        <MobileHeaderAppBar className={headerClass}>
            <Toolbar>
                <MobileHeaderLogo onClick={goToHomepage}>
                    <LogoSvg fill={logoColor}/>
                </MobileHeaderLogo>
                <BurgerButton className={headerClass} onClick={toggleMenu}>
                    <b/>
                    <b/>
                    <b/>
                </BurgerButton>
                <Drawer open={menuOpen} anchor={"right"}>
                    <MobileMenu toggleMobileMenu={toggleMenu} />
                </Drawer>
            </Toolbar>
        </MobileHeaderAppBar>
    )
}